<a
  class="sidebar-link sidebar-link-user truncate"
  [routerLink]="settingsRoute()"
  routerLinkActive="active"
  (click)="onClick()"
>
  <div class="sidebar-link-image sidebar-link-image-avatar mx-auto justify-center md:mx-0">
    <dojo-profile-avatar [size]="30" class="shrink-0" />
  </div>
  <span class="sidebar-link-text" [matTooltip]="user().fullName">{{ user().fullName }}</span>
</a>
